document.addEventListener('DOMContentLoaded', function () {
  // 全バリアントのsumaregi_idを取得
  const smaregiIds = window.smaregiIds;

  function accessProxy(_selectProductId) {
    return new Promise((resolve, reject) => {
      fetch(`/apps/smaregi-cooperation?product_id=${_selectProductId}`, {
        method: 'POST',
        redirect: 'manual',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          resolve(data);
        })
        .catch((error) => {
          console.log(`Error for ${_selectProductId}:`, error);
          reject(error);
          console.log('改めて在庫を検索してください');
        });
    });
  }

  // 店舗在庫データを表示する関数
  function displayStoreStock(smaregiData) {
    const storeStockElements = document.querySelectorAll('.c-product-stock-stock-list');
    
    // 各店舗について処理
    storeStockElements.forEach(storeElement => {
      const storeId = storeElement.getAttribute('data-store-id');
      const stockAmountElements = storeElement.querySelectorAll('[data-stock-variant-id]');
      
      stockAmountElements.forEach(stockElement => {
        const variantSmaregiId = stockElement.getAttribute('data-stock-variant-id');
        let stockStatus = '×';
        
        smaregiData.forEach(variantData => {
          if (variantData.smaregiId === variantSmaregiId && variantData.data && variantData.data.productStock) {
            const storeStock = variantData.data.productStock.find(stock => stock.storeId === storeId);
            if (storeStock && storeStock.stockAmount >= 1) {
              stockStatus = '◯';
            }
          }
        });
        
        stockElement.textContent = stockStatus;
      });
    });
  }

  async function fetchAllSmaregiData() {
    if (smaregiIds.length === 0) {
      console.log('No smaregi IDs found');
      return;
    }
    
    const allSmaregiData = [];

    for (let i = 0; i < smaregiIds.length; i++) {
      const item = smaregiIds[i];
      try {
        const data = await accessProxy(item.smaregiId);
        
        allSmaregiData.push({
          smaregiId: item.smaregiId,
          variantId: item.variantId,
          data: data
        });
      } catch (error) {
        console.error(`✗ Failed to fetch data for variant ${item.variantId}:`, error);
      }
      
      // 次のリクエストまで少し待機（サーバー負荷軽減のため）
      if (i < smaregiIds.length - 1) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    console.log('All smaregi data:', allSmaregiData);
    
    // 取得完了後に店舗在庫を表示
    displayStoreStock(allSmaregiData);
  }

  // 在庫情報の取得を開始
  fetchAllSmaregiData();
});